/* eslint-disable @typescript-eslint/no-explicit-any */
import { Children, ReactNode, useEffect, useRef } from 'react';
import {
  loadUserFromStorage,
  signinSilent
} from '../services/authService';
import { httpServices } from '../services/httpServices';
import { getUser } from '../utils/auth';
import { showModal } from '../components/EpModal';
import { MODAL_TIMEOUT_ID } from '../constants/authConstants';
import { useAuthStore } from '../stores/useAuthStore';
import useUserActivity from '../hooks/useUserActivity';

interface AuthProviderProps {
  userManager: any;
  children: ReactNode;
}
export default function AuthProvider({
  userManager: manager,
  children,
}: AuthProviderProps) {
  const userManager = useRef<any>();
  const { isActivity } = useAuthStore();

  const user = getUser();
  // const userManagerCurrent = userManager.current  as any

  const { setAuthHeader } = httpServices;

  useUserActivity();

  useEffect(() => {
    (userManager.current as any) = manager;

    const onUserLoaded = () => {
      loadUserFromStorage();
    };

    const onUserUnloaded = () => {
      setAuthHeader(null);
    };

    const onAccessTokenExpired = () => {
      showModal(MODAL_TIMEOUT_ID);
    };

    const onAccessTokenExpiring = () => {
      if (isActivity) {
        signinSilent();
      } else {
        showModal(MODAL_TIMEOUT_ID);
      };
    };

    const onUserSignedOut = () => {
      console.log('User signed out');
    };

    userManager.current.events.addUserLoaded(onUserLoaded);
    userManager.current.events.addUserUnloaded(onUserUnloaded);
    userManager.current.events.addAccessTokenExpiring(onAccessTokenExpiring);
    userManager.current.events.addAccessTokenExpired(onAccessTokenExpired);
    userManager.current.events.addUserSignedOut(onUserSignedOut);

    return function cleanup() {
      userManager.current.events.removeUserLoaded(onUserLoaded);
      userManager.current.events.removeUserUnloaded(onUserUnloaded);
      userManager.current.events.removeAccessTokenExpiring(
        onAccessTokenExpiring,
      );
      userManager.current.events.removeAccessTokenExpired(onAccessTokenExpired);
      // eslint-disable-next-line react-hooks/exhaustive-deps
      userManager.current.events.removeUserSignedOut(onUserSignedOut);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manager, user]); //, activityState

  return Children.only(children);
}
